export default __webpack_public_path__ + "static/media/analytics-download-bg.e499d6fb.png";